<template>
    <div class="countDownTimer">
        <div class="days">
            <div class="num">
                <div class="digit">{{days_digit}}</div>
                <div>{{days_ten_digit}}</div>
            </div>
            <div class="unit">DAYS</div>
        </div>
        <div class="hours">
            <div class="num">
                <div class="digit">{{hours_digit}}</div>
                <div>{{hours_ten_digit}}</div>
            </div>
            <div class="unit">HOURS</div>
        </div>
        <div class="minutes">
            <div class="num">
                <div class="digit">{{minutes_digit}}</div>
                <div>{{minutes_ten_digit}}</div>
            </div>
            <div class="unit">MINUTES</div>
        </div>
        <div class="seconds">
            <div class="num">
                <div class="digit">{{seconds_digit}}</div>
                <div>{{seconds_ten_digit}}</div>
            </div>
            <div class="unit">SECONDS</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            fanfare_end_time: String,
        },

        data() {
            return{
                countDownInterval:"",
                now: "",
                days_digit: "",
                days_ten_digit: "",
                hours_digit: "",
                hours_ten_digit: "",
                minutes_digit: "",
                minutes_ten_digit: "",
                seconds_digit: "",
                seconds_ten_digit: "",
            }
        },

        computed: {

        },

        methods:{
            countDownTimer(){
                this.endDate = new Date(this.fanfare_end_time).getTime();
                this.countDownInterval = setInterval(() => {
                    // Get todays date and time
                    this.now = new Date().getTime();
                    // Find the distance between now and the count down date
                    let distance = this.endDate - this.now;
                    // Time calculations for days, hours, minutes and seconds
                    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
                    let hours = Math.floor(
                        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
                    );
                    let minutes = Math.floor(
                        (distance % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    let seconds = Math.floor((distance % (1000 * 60)) / 1000);
                    function pad(number) {
                        return (number < 10 ? "0" : "") + number;
                    }

                    if (distance <= 0) {
                        days = 0;
                        hours = 0;
                        minutes = 0;
                        seconds = 0;
                        clearInterval(this.countDownInterval);
                    }
                    this.days_digit = pad(days).split("")[0];
                    this.days_ten_digit = pad(days).split("")[1];
                    this.hours_digit = pad(hours).split("")[0];
                    this.hours_ten_digit = pad(hours).split("")[1];
                    this.minutes_digit = pad(minutes).split("")[0];
                    this.minutes_ten_digit = pad(minutes).split("")[1];
                    this.seconds_digit = pad(seconds).split("")[0];
                    this.seconds_ten_digit = pad(seconds).split("")[1];

                    // If the count down is over, write some text
                    // if (distance < 0) {
                    // 	clearInterval(x);
                    // 	document.getElementById("demo").innerHTML = "EXPIRED";
                    // }
                }, 1000);
            }

        },

        mounted() {
            this.countDownTimer();

        }
    }

</script>

<style scoped lang="scss">
    .countDownTimer{
        display: flex;
        justify-content: center;
        .days,
        .hours,
        .minutes,
        .seconds {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-right: 16px;
        }
        .seconds {
            margin-right: 0 !important;
        }
        .unit {
            margin-top: 8px;
            color: rgba(82, 97, 107, 0.6);
            font-size: 10px;
            font-weight: 600;
        }
        .num{
            display: flex;
            div {
                font-size: 24px;
                font-weight: bold;
                color: #ffffff;
                background: #333333;
                border-radius: 5px;
                width: 32px;
                height: 40px;
                text-align: center;
            }
            .digit {
                margin-right: 4px;
            }
        }
    }

</style>